<onyx-section heading="labels.beginning">
  @let controls = form().controls;
  <form [formGroup]="form()">
    <onyx-form-group [controls]="controls.departurePlace">
      <onyx-address-input
        [formControl]="controls.departurePlace"
        label="labels.address"
        [showApartment]="true"
        apartmentWidth="80px"
        [showErrors]="false"
        [size]="32"
      ></onyx-address-input>

      <onyx-suggestions
        [control]="controls.departurePlace"
        [suggestions]="addressSuggestions()"
      ></onyx-suggestions>
    </onyx-form-group>

    <onyx-form-group [controls]="controls.departureDate">
      <onyx-datepicker
        [formControl]="controls.departureDate"
        [label]="`labels.${hasDailyReturns() ? 'startDate' : 'departureDate'}`"
        [showErrors]="false"
        [warningTypes]="['pastDate']"
        [size]="32"
      ></onyx-datepicker>

      <onyx-suggestions
        [control]="controls.departureDate"
        [suggestions]="DATE_SUGGESTIONS"
      ></onyx-suggestions>
    </onyx-form-group>

    <onyx-timepicker
      [formControl]="controls.departureTime"
      [label]="`labels.${hasDailyReturns() ? 'departureTimes' : 'departureTime'}`"
      [size]="32"
    ></onyx-timepicker>
  </form>
</onyx-section>
